export default function Node_PackageJson() {
  return <div>Node_PackageJson Component</div>;
}
